import React, { Component } from "react";
import {LOGIN_TYPE_ADMIN, api_sources, CLIENT_ADD_EDIT_NEW_EXIST_SERVICE, API_DOC_URL, PLAN_STATUS_CHANGE} from "./../helper/Constants";
import Apihelpers from "./../helper/ApiHelper";
import {Alert } from 'rsuite';
import { reactLocalStorage } from 'reactjs-localstorage';
import $ from "jquery";
//import Select2 from 'react-select2-wrapper';

export default class PlanList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planlist: this.props.list || [],
      bbUser: this.props.bbUser || {},
      masterServices: this.props.masterServices || [],
      addPlanPopup: false,
      //planAmount:0,
      formType: 'Add',
      crPlan:{},
      groups:[]
    }
  }

  componentDidMount() {
    $(".clientEditPage").on(".add-new-plan select2:select", function (evt) {
      var element = evt.params.data.element;
      //console.log('element',element);
      var $element = $(element);
      let id = evt.target.id;
      //console.log('select2 id',id);
      $element.detach();
      $('#'+id).append($element);
      $('#'+id).trigger("change");
    })
    if(this.state.planlist.length > 0) {
      let resArray = [...this.state.planlist];
      resArray = resArray.map((plan)=>({...plan, hasChild:'no', childs:[], traversing_dependency: 'parent'}));

      resArray.forEach((plan)=>{
        let serObj = this.state.masterServices.filter((it)=>(it.serviceName === plan.plantype));
        //console.log('serObj',serObj);
        if(serObj[0].traversing_dependency === 'child'){
          let parentIds = serObj[0].parent_id;
          if(parentIds !== undefined){
            parentIds.forEach((pls)=>{
              let parentIdObj = this.state.masterServices.filter((it)=>(it._id === pls));
              //console.log('parentIdObj',parentIdObj[0].serviceName);
              let index = resArray.findIndex((pl)=>(pl.plantype === parentIdObj[0]?.serviceName));
              //console.log('index',index);
              let newArray = resArray[index]?.childs;
              if(index !== -1) {
                resArray[index].hasChild = 'yes';
                resArray[index].traversing_dependency = 'child';
                newArray.push(plan.plantype);
                resArray[index].childs = newArray;
                if(plan.isActive === 1) {
                  if(resArray[index].isActive === 1) {
                    resArray[index].hasChildActive = true;
                  }
                }
              }
            })
          }
        }
      });
      resArray.forEach((plan,ind)=>{
        if(plan.traversing_dependency === 'child') {
          if(plan.isActive === 0) {
            if(plan.childs.length > 0) {
              plan.childs.forEach((ite)=>{
                let index = resArray.findIndex((pl)=>(ite === pl.plantype));
                resArray[index].HasParentInActive = true;
              })
            }
          }
          if(plan.childs.length > 0) {
            plan.childs.forEach((ite)=>{
              let index = resArray.findIndex((pl)=>(ite === pl.plantype));
              if(resArray[index].traversing_dependency !== 'parent') {
                resArray[index].parentAlsoChild = 'yes';
              }
            })
          }
        }
      })
      this.setState({planlist:resArray});
    }

    // let urlParmes = new URL(window.location.href).searchParams.get('shouldBeAdd');
    // if(urlParmes !== null && urlParmes.trim() !== '') {
    //   console.log('urlParmes',urlParmes);
    //   this.setState({addPlanPopup:true,crPlan:{},formType:'Add'});
    //   this.changePlan(urlParmes);
    //   Alert.info("This plan depends on another service. Please configure the required child service.", 3000);
    // }
    setTimeout(()=>{
      this.groupPlans();
    },100);
  }

  changePlan = (planType) => {
    let serObj = this.state.masterServices.filter((it)=>{
      return (it.serviceName === planType);
    });
    console.log('serObj',serObj);
    this.setState({crPlan:serObj[0] || {}});
  }

  addinationalField = (serviceName) => {
    if (serviceName === 'RCPrime') {
      //console.log('rc prime extra info here...');
      setTimeout(function () {
        $("#rcPrimeSourceOrder").select2({
          placeholder: "type source name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      var perDayLIMIT = this.state.bbUser.per_day_limit;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      let cache_days = "";
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        cache_days = this.state.bbUser.rc_prime_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.rc_prime_api_source_order;
      }
      let rcPrimeDefault = this.arrayOrderManage(api_sources.RCPrime, source_order);
      return (
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">RC Prime API Source Order</label>
              <select className="form-control" multiple="multiple" id="rcPrimeSourceOrder" style={{ width: "100%" }}>
                {rcPrimeDefault.map((it, i) => {
                  let selt = false;
                  if (source_order.indexOf(it) !== -1) {
                    selt = true;
                  }
                  if (it.length > 0) {
                    return <option key={i} selected={selt}>{it}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Cache Days</label>
              <input id="rcPrimeCacheDays" type="number" name="" className="form-control" defaultValue={cache_days} />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name="" id="perDayLimit" defaultValue={perDayLIMIT} /></div>
          </div>
        </>
      )
    } else if (serviceName === 'RCExcel') {
      setTimeout(function () {
        $("#rcExcelSourceOrder").select2({
          placeholder: "type name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      let cache_days = "";
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        cache_days = this.state.bbUser.rc_excel_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.rc_excel_api_source_order;
      }
      let rcPrimeExcelDefault = this.arrayOrderManage(api_sources.RCExcel, source_order);
      return(
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">
                RCExcel bulk upload source order
              </label>
              <select className="form-control" multiple="multiple" id="rcExcelSourceOrder" style={{ width: "100%" }}>
                {rcPrimeExcelDefault.map((ip, i) => {
                  let selt = false;
                  if (source_order.indexOf(ip) !== -1) {
                    selt = true;
                  }
                  if (ip.length > 0) {
                    return <option key={i} selected={selt}>{ip}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Cache days</label>
              <input type="number" name="" id="rcExcelCacheDays" defaultValue={cache_days} className="form-control" />
            </div>
          </div>
        </>
      )
    } else if (serviceName === 'comboMobilePrimeExcel') {
      setTimeout(function () {
        $("#mobileRCExcelSourceOrder").select2({
          placeholder: "type name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      let cache_days = "";
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        cache_days = this.state.bbUser.mobile_rc_excel_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.mobile_rc_excel_api_source_order_for_Api;
      }
      let rcPrimeExcelDefault = this.arrayOrderManage(api_sources.MobileRCExcel, source_order);
      return(
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">
                Mobile RC Excel bulk upload source order
              </label>
              <select className="form-control" multiple="multiple" id="mobileRCExcelSourceOrder" style={{ width: "100%" }}>
                {rcPrimeExcelDefault.map((ip, i) => {
                  let selt = false;
                  if (source_order.indexOf(ip) !== -1) {
                    selt = true;
                  }
                  if (ip.length > 0) {
                    return <option key={i} selected={selt}>{ip}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Cache days</label>
              <input type="number" name="" id="mobileRCExcelCacheDays" defaultValue={cache_days} className="form-control" />
            </div>
          </div>
        </>
      )
    } else if (serviceName === 'ChallanExcel') {
      setTimeout(function () {
        $("#challanExcelSourceOrder").select2({
          placeholder: "type name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      let cache_days = "";
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        cache_days = this.state.bbUser.challan_excel_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.challan_excel_api_source_order;
      }
      let challanExcelDefault = this.arrayOrderManage(api_sources.ChallanExcel, source_order);
      return(
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">
                Challan Excel bulk upload source order
              </label>
              <select className="form-control" multiple="multiple" id="challanExcelSourceOrder" style={{ width: "100%" }}>
                {challanExcelDefault.map((ip, i) => {
                  let selt = false;
                  if (source_order.indexOf(ip) !== -1) {
                    selt = true;
                  }
                  if (ip.length > 0) {
                    return <option key={i} selected={selt}>{ip}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Cache days</label>
              <input type="number" name="" id="challanExcelCacheDays" defaultValue={cache_days} className="form-control" />
            </div>
          </div>
        </>
      )
    } else if (serviceName === 'Challan') {
      console.log('challan extra info here...');
      setTimeout(function () {
        $("#challanSourceOrder").select2({
          placeholder: "type source name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      var perDayLIMIT = this.state.bbUser.per_day_limit_for_challan;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      //var currentPlan = this.state.bbActivePlan.service[(selectPlan - 1)];
      //console.log('currentPlan',currentPlan);
      let cache_days = "";
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        if (this.state.bbUser?.challan_owndb_cache_days_for_Api !== null) {
          cache_days = this.state.bbUser.challan_owndb_cache_days_for_Api;
        }
        if (this.state.bbUser?.challan_api_source_order !== null) {
          source_order = this.state.bbUser.challan_api_source_order;
        }
      }
      
      let challanDefault = this.arrayOrderManage(api_sources.Challan, source_order);
      return (
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">Challan API Source Order</label>
              <select className="form-control" multiple="multiple" id="challanSourceOrder" style={{ width: "100%" }}>
                {challanDefault.map((it, i) => {
                  let selt = false;
                  if (source_order.indexOf(it) !== -1) {
                    selt = true;
                  }
                  if (it.length > 0) {
                    return <option key={i} selected={selt}>{it}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Cache Days</label>
              <input id="challanCacheDays" type="number" name="" className="form-control" defaultValue={cache_days} />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name="" id="perDayLimitChallan" defaultValue={perDayLIMIT} /></div>
          </div>
        </>
      )
    } else if (serviceName === 'comboPrime') {
      console.log('RCPrimeChallan extra info here...');
      setTimeout(function () {
        $("#rcPrimeChallanPrimeSourceOrder").select2({
          placeholder: "type source name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      setTimeout(function () {
        $("#rcPrimeChallanchallanSourceOrder").select2({
          placeholder: "type source name",
          tags: false,
          tokenSeparators: [',', ' ']
        });
      }, 100);
      let cache_days = "";
      let challan_cache_days = "";
      let challan_source_order = [];
      let source_order = [];
      if (this.state.bbUser !== undefined) {
        if (this.state.bbUser?.rcPrimeChallan_prime_owndb_cache_days !== null) {
          cache_days = this.state.bbUser.rcPrimeChallan_prime_owndb_cache_days;
        }
        if (this.state.bbUser?.rcPrimeChallan_prime_source_order !== null) {
          source_order = this.state.bbUser.rcPrimeChallan_prime_source_order;
        }
        if (this.state.bbUser?.rcPrimeChallan_challan_owndb_cache_days !== null) {
          challan_cache_days = this.state.bbUser.rcPrimeChallan_challan_owndb_cache_days;
        }
        if (this.state.bbUser?.rcPrimeChallan_challan_source_order !== null) {
          challan_source_order = this.state.bbUser.rcPrimeChallan_challan_source_order;
        }
      }
      
      let primeDefault = this.arrayOrderManage(api_sources.RCPrime, source_order);
      let challanDefault = this.arrayOrderManage(api_sources.Challan, challan_source_order);
      return (
        <>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">RCPrimeChallan Prime API Source Order</label>
              <select className="form-control" multiple="multiple" id="rcPrimeChallanPrimeSourceOrder" style={{ width: "100%" }}>
                {primeDefault.map((it, i) => {
                  let selt = false;
                  if (source_order.indexOf(it) !== -1) {
                    selt = true;
                  }
                  if (it.length > 0) {
                    return <option key={i} selected={selt}>{it}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="control-title">Prime Cache Days</label>
              <input id="rcPrimeChallanPrimeCacheDays" type="number" name="" className="form-control" defaultValue={cache_days} />
            </div>
          </div>
          <div className="col-md-8">
            <div className="form-group">
              <label className="control-title">RCPrimeChallan Challan API Source Order</label>
              <select className="form-control" multiple="multiple" id="rcPrimeChallanchallanSourceOrder" style={{ width: "100%" }}>
                {challanDefault.map((it, i) => {
                  let selt = false;
                  if (challan_source_order.indexOf(it) !== -1) {
                    selt = true;
                  }
                  if (it.length > 0) {
                    return <option key={i} selected={selt}>{it}</option>
                  }
                })}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group"><label className="control-title">Challan Cache Days</label><input className="form-control" type="number" name="" id="rcPrimeChallanchallanCacheDays" defaultValue={challan_cache_days} /></div>
          </div>
        </>
      )
    } else if (serviceName === 'RCPrimeReverse') {
      console.log('RCPrimeReverse info here...');
      var perDayLIMIT = this.state.bbUser.per_day_limit_for_rc_prime_reverse;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name="" id="perDayLimitRCPrimeReverse" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    } else if (serviceName === 'RCPrimeReverseBasic') {
      console.log('RCPrimeReverseBasic info here...');
      var perDayLIMIT = this.state.bbUser.per_day_limit_for_rc_prime_reverse_basic;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name=""  id="perDayLimitRCPrimeReverseBasic" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    } else if (serviceName === 'UsedCarPricing') {
      console.log('UsedCarPricing info here...');
      var perDayLIMIT = this.state.bbUser.per_day_limit_for_used_car_pricing;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name="" id="perDayLimitUsedCarPricing" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    } else if (serviceName === 'UsedCarPricingV2') {
      console.log('UsedCarPricingv2 info here...');
      var perDayLIMIT = this.state.bbUser.per_day_limit_for_used_car_pricing_v2;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title">Per day Api Hit Limit</label><input className="form-control" type="number" name="" id="perDayLimitUsedCarPricingV2" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    } else if (serviceName === 'AadhaarFetch') {
      console.log('AadhaarFetch info here...');
      var perDayLIMIT = this.state.bbUser.aadhaarFetch_owndb_cache_days;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title"> Cache Days</label><input className="form-control" type="number" name="" id="perDayLimitAadhaarFetch" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    } else if (serviceName === 'PanFetch') {
      console.log('PanFetch info here...');
      var perDayLIMIT = this.state.bbUser.panFetch_owndb_cache_days;
      if(perDayLIMIT === 0 || perDayLIMIT === null) {
        perDayLIMIT = '';
      }
      return (
        <div className="col-4">
          <div className="form-group"><label className="control-title"> Cache Days</label><input className="form-control" type="number" name="" id="perDayLimitPanFetch" defaultValue={perDayLIMIT} /></div>
        </div>
      )
    }
  }

  arrayOrderManage = (defaultArray, valueArray) => {
    valueArray.forEach(ele => {
      if (valueArray.indexOf(ele) > -1) {
        defaultArray.splice(defaultArray.indexOf(ele),1);
        defaultArray.push(ele);
      }
    });
    return defaultArray;
  }

  updatePlanFun = (e) => {
    e.preventDefault();
    let existPlan = JSON.parse(this.state.bbUser.active_plan);
    //console.log('existPlan',existPlan);
    let date = new Date();
    let min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    var cruntDate = date.getDate()+"-"+(date.getMonth()+1)+"-"+date.getFullYear() + " "+date.getHours()+":"+min;

    let crObj = {
      plantype:this.state.crPlan.serviceName, 
      planamount:1,
      isActive:1,
      createdAt:cruntDate,
      updatedAt:cruntDate
    }
    
    if(this.state.formType === 'Add'){
      existPlan.service.push(crObj);
      let depandPlns = $(".dipandePlan");
      if(depandPlns.length > 0) {
        depandPlns.each(function(index, element) {
          let depnCrPln = $(element).attr('data-plankey');
          existPlan.service.push({
            plantype:depnCrPln, 
            planamount:1,
            isActive:1,
            createdAt:cruntDate,
            updatedAt:cruntDate
          });
        })
      } 
      //console.log('depandPlns',depandPlns);
    } else {
      let plIndx = existPlan.service.findIndex((it)=>(it.plantype === this.state.crPlan.serviceName));
      //console.log('plIndx',plIndx);
      if(existPlan.service[plIndx].updatedAt !== undefined) {
        crObj.updatedAt = existPlan.service[plIndx].updatedAt;
      }
      existPlan.service[plIndx] = crObj
    }
    let updateObj = {};
    updateObj.crObj = crObj;
    updateObj.active_plan = JSON.stringify(existPlan);

    if($("#perDayLimit").val() !== undefined) {
      updateObj.per_day_limit= $("#perDayLimit").val();
      if(Number($("#perDayLimit").val()) > 0) {
        updateObj.per_day_limit_enable = true;
      } else {
        updateObj.per_day_limit_enable = false;
      }
      if($("#rcPrimeCacheDays").val() === "") {
        updateObj.rc_prime_owndb_cache_days_for_Api = null;
      } else {
        updateObj.rc_prime_owndb_cache_days_for_Api= $("#rcPrimeCacheDays").val();
      }
      updateObj.rc_prime_api_source_order= $("#rcPrimeSourceOrder").val();
    }
    if($("#perDayLimitChallan").val() !== undefined) {
      updateObj.per_day_limit_for_challan= $("#perDayLimitChallan").val();
      if(Number($("#perDayLimitChallan").val()) > 0) {
        updateObj.per_day_limit_for_challan_enable = true;
      } else {
        updateObj.per_day_limit_for_challan_enable = false;
      }
      if(Number($("#perDayLimitChallan").val()) > 0) {
        updateObj.per_day_limit_for_challan_enable = true;
      } else {
        updateObj.per_day_limit_for_challan_enable = false;
      }
      updateObj.challan_api_source_order= $("#challanSourceOrder").val();
      if($("#challanCacheDays").val() === "") {
        updateObj.challan_owndb_cache_days_for_Api= null;
      } else {
        updateObj.challan_owndb_cache_days_for_Api= $("#challanCacheDays").val();
      }
    }
    if($("#rcPrimeChallanPrimeSourceOrder").val() !== undefined) {
      updateObj.rcPrimeChallan_prime_source_order= $("#rcPrimeChallanPrimeSourceOrder").val();
      
      updateObj.rcPrimeChallan_challan_source_order= $("#rcPrimeChallanchallanSourceOrder").val();
      if($("#rcPrimeChallanPrimeCacheDays").val() === ""){
        updateObj.rcPrimeChallan_prime_owndb_cache_days = null;
      }else {
        updateObj.rcPrimeChallan_prime_owndb_cache_days= $("#rcPrimeChallanPrimeCacheDays").val();
      }
      if($("#rcPrimeChallanchallanCacheDays").val() === '') {
        updateObj.rcPrimeChallan_challan_owndb_cache_days = null;
      } else {
        updateObj.rcPrimeChallan_challan_owndb_cache_days= $("#rcPrimeChallanchallanCacheDays").val();
      }
    }
    if($("#perDayLimitRCPrimeReverse").val() !== undefined) {
      updateObj.per_day_limit_for_rc_prime_reverse = $("#perDayLimitRCPrimeReverse").val();
      if(Number($("#perDayLimitRCPrimeReverse").val()) > 0) {
        updateObj.per_day_limit_for_rc_prime_reverse_enable = true;
      } else {
        updateObj.per_day_limit_for_rc_prime_reverse_enable = false;
      }
    }
    if($("#perDayLimitRCPrimeReverseBasic").val() !== undefined) {
      updateObj.per_day_limit_for_rc_prime_reverse_basic= $("#perDayLimitRCPrimeReverseBasic").val();
      if(Number($("#perDayLimitRCPrimeReverseBasic").val()) > 0) {
        updateObj.per_day_limit_for_rc_prime_reverse_basic_enable= true;
      } else {
        updateObj.per_day_limit_for_rc_prime_reverse_basic_enable= false;
      }
    }
    if($("#perDayLimitUsedCarPricing").val() !== undefined) {
      updateObj.per_day_limit_for_used_car_pricing= $("#perDayLimitUsedCarPricing").val();
      if(Number($("#perDayLimitUsedCarPricing").val())) {
        updateObj.per_day_limit_for_used_car_pricing_enable= true;
      } else {
        updateObj.per_day_limit_for_used_car_pricing_enable= false;
      }
    }
    if($("#perDayLimitUsedCarPricingV2").val() !== undefined) {
      updateObj.per_day_limit_for_used_car_pricing_v2= $("#perDayLimitUsedCarPricingV2").val();
      if(Number($("#perDayLimitUsedCarPricingV2").val()) > 0) {
        updateObj.per_day_limit_for_used_car_pricing_v2_enable= true;
      } else {
        updateObj.per_day_limit_for_used_car_pricing_v2_enable= false;
      }
    }
    if($("#rcExcelSourceOrder").val() !== undefined) {
      updateObj.rc_excel_api_source_order= $("#rcExcelSourceOrder").val();
      if($("#rcExcelCacheDays").val() === '') {
        updateObj.rc_excel_owndb_cache_days_for_Api = null;
      } else {
        updateObj.rc_excel_owndb_cache_days_for_Api= $("#rcExcelCacheDays").val();
      }
    }
    if($("#mobileRCExcelSourceOrder").val() !== undefined) {
      updateObj.mobile_rc_excel_api_source_order_for_Api= $("#mobileRCExcelSourceOrder").val();
      if($("#mobileRCExcelCacheDays").val() === '') {
        updateObj.mobile_rc_excel_owndb_cache_days_for_Api = null;
      } else {
        updateObj.mobile_rc_excel_owndb_cache_days_for_Api= $("#mobileRCExcelCacheDays").val();
      }
    }
    if($("#challanExcelSourceOrder").val() !== undefined) {
      updateObj.challan_excel_api_source_order= $("#challanExcelSourceOrder").val();
      if($("#challanExcelCacheDays").val() === '') {
        updateObj.challan_excel_owndb_cache_days_for_Api= null;
      } else {
        updateObj.challan_excel_owndb_cache_days_for_Api= $("#challanExcelCacheDays").val();
      }
    }

    if($("#perDayLimitAadhaarFetch").val() !== undefined) {
      updateObj.aadhaarFetch_owndb_cache_days = $("#perDayLimitAadhaarFetch").val();
    }
    if($("#perDayLimitPanFetch").val() !== undefined) {
      updateObj.panFetch_owndb_cache_days = $("#perDayLimitPanFetch").val();
    }


    //console.log('updateObj',updateObj);
    //return;
    $(".loader").show();
    Apihelpers.postdataresponse(CLIENT_ADD_EDIT_NEW_EXIST_SERVICE + this.state.bbUser._id, updateObj).then(res => {
      //console.log('res',res);
      if (res.data.status === true) {
        Alert.success("Service Added Successfully");
        setTimeout(()=>{
          window.location.href = window.location.origin + window.location.pathname;
        },2000);
        
      } else {
        Alert.success("Error While Add Service");
      }
    });
  }
  
  planPrint = (obj,index,serObj, hideSwitch='no') => {
    console.log('call plan print fun.');
    let url = "--";
    if(serObj.service_url !== '' && serObj.service_url !== undefined) {
      if(serObj.service_use_type === 'panel') {
        let pagUrl = API_DOC_URL+serObj.service_url;
        url = (<a target="_blank" href={pagUrl}>{serObj.service_name}</a>);
      } else if (serObj.service_use_type === 'api') {
        url = Apihelpers.getBaseUrl()+serObj.service_url;
      }
      
    }
    let doc = "--";
    if(serObj.service_document !== '' && serObj.service_document !== undefined) {
      doc = (<a target="_blank" href={Apihelpers.getBaseUrl()+'api_documents/'+serObj.service_document} title="Download API Document"><i className="fa fa-download"></i></a>);
    }
    let editBtn = false;
    if(reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      editBtn = true;
    }

    let addinfo;
    let ips, hitlimit;
    let planInfo;
    let source_order, challan_source_order;
    let cache_days, challan_cache_days;
    if (obj.plantype == 'RCPrime') {
      hitlimit = this.state.bbUser.per_day_limit;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (obj.plantype == 'Challan') {
      hitlimit = this.state.bbUser.per_day_limit_for_challan;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (obj.plantype == 'RCPrimeReverse') {
      hitlimit = this.state.bbUser.per_day_limit_for_rc_prime_reverse;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (obj.plantype == 'RCPrimeReverseBasic') {
      hitlimit = this.state.bbUser.per_day_limit_for_rc_prime_reverse_basic;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (obj.plantype == 'UsedCarPricing') {
      hitlimit = this.state.bbUser.per_day_limit_for_used_car_pricing;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (obj.plantype == 'UsedCarPricingV2') {
      hitlimit = this.state.bbUser.per_day_limit_for_used_car_pricing_v2;
      planInfo = (<tr className="addinfo"><td>Hit Limit</td><td colSpan="4">{hitlimit}  Per Day</td></tr>);
    }
    if (reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN) {
      if (obj.plantype == 'RCPrime') {
        //if (obj.settingDetails !== undefined) {
          cache_days = this.state.bbUser.rc_prime_owndb_cache_days_for_Api;
          source_order = this.state.bbUser.rc_prime_api_source_order;
          cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
          source_order = (<tr className="addinfo"><td>API Source Order</td><td colSpan="4">
            {source_order.map((api, ind) => {
              return <span key={ind}>{api}</span>
            })}
          </td>
          </tr>);
        //}
      }
      if (obj.plantype == 'RCExcel') {
          cache_days = this.state.bbUser.rc_excel_owndb_cache_days_for_Api;
          source_order = this.state.bbUser.rc_excel_api_source_order;
          cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
          source_order = (<tr className="addinfo"><td>API Source Order</td><td colSpan="4">
            {source_order.map((api, index) => {
              return <span key={index}>{api}</span>
            })}
          </td>
          </tr>);
        //}
      }
      if (obj.plantype == 'comboMobilePrimeExcel') {
        cache_days = this.state.bbUser.mobile_rc_excel_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.mobile_rc_excel_api_source_order_for_Api;
        cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
        source_order = (<tr className="addinfo"><td>API Source Order</td><td colSpan="4">
          {source_order.map((api, index) => {
            return <span key={index}>{api}</span>
          })}
        </td>
        </tr>);
      //}
    }
      if (obj.plantype == 'ChallanExcel') {
        cache_days = this.state.bbUser.challan_excel_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.challan_excel_api_source_order;
        cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
        source_order = (<tr className="addinfo"><td>API Source Order</td><td colSpan="4">
          {source_order?.map((api, index) => {
            return <span key={index}>{api}</span>
          })}
        </td>
        </tr>);
      //}
    }
      if (obj.plantype == 'Challan') {
        cache_days = this.state.bbUser.challan_owndb_cache_days_for_Api;
        source_order = this.state.bbUser.challan_api_source_order;
        
        cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
        source_order = (<tr className="addinfo"><td>API Source Order</td><td colSpan="4">
          {source_order.map((api, index) => {
            return <span key={index}>{api}</span>
            })}
          </td>
        </tr>);
      }
      if (obj.plantype == 'comboPrime') {
        cache_days = this.state.bbUser.rcPrimeChallan_prime_owndb_cache_days;
        challan_cache_days = this.state.bbUser.rcPrimeChallan_challan_owndb_cache_days;
        source_order = this.state.bbUser.rcPrimeChallan_prime_source_order;
        challan_source_order = this.state.bbUser.rcPrimeChallan_challan_source_order;
          cache_days = (<tr className="addinfo"><td>Prime Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
          source_order = (<tr className="addinfo"><td>API RC Prime Source Order</td><td colSpan="4">
            {source_order.map((api, ind) => {
              return <span key={ind}>{api}</span>
            })}
          </td>
          </tr>);
          challan_cache_days = (<tr className="addinfo"><td>Challan Cache Days</td><td colSpan="4">{challan_cache_days}</td></tr>);
          challan_source_order = (<tr className="addinfo"><td>API RC Challan Source Order</td><td colSpan="4">
          {challan_source_order.map((api, ind) => {
            return <span key={ind}>{api}</span>
          })}
        </td>
        </tr>);
      }
      if (obj.plantype == 'PanFetch') {
        cache_days = this.state.bbUser.panFetch_owndb_cache_days;
        cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
      }
      if (obj.plantype == 'AadhaarFetch') {
        cache_days = this.state.bbUser.aadhaarFetch_owndb_cache_days;
        cache_days = (<tr className="addinfo"><td>Cache Days</td><td colSpan="4">{cache_days}</td></tr>);
      }
    }
    let createdAt = (<span className="date">--</span>);
    if(obj.createdAt !== undefined) {
      let title = 'Created At:'+obj.createdAt+', Updated At:'+obj.updatedAt;
      createdAt = (<span className="date" title={title}>{obj.createdAt}</span>);
    }
    let toolTipInfo = '';
    if (obj.plantype == 'MobileExcel' || obj.plantype == 'comboMobilePrimeExcel') {
      toolTipInfo += '<div class="toolTip"><i class="infoIcon"></i><div class="toolTipText">For "Bulk Mobile RC Upload" required two plans (MobileExcel and comboMobilePrimeExcel) </div></div>';
    }

    
    //childRow
    if (serObj.traversing_dependency === 'child') {
      console.log('if going in return',serObj.traversing_dependency);
      return(
        <>
        <tr>
          <td className="childRow" colSpan={5}>
            <table className="table">
            <tbody>
            <tr>
              <td style={{width:'25%'}}>
                {obj.plantype}
                {(serObj.traversing_dependency === 'child')? <span className="subTxt"> (Dependent plan) </span> : ''}
                {createdAt}
              </td>
              <td>{url}</td>
              <td style={{'width':'70px'}}>{doc}</td>
              <td style={{'width':'110px'}}>
                {
                  (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <> {
                    (hideSwitch !== 'yes') ?
                    <label className="switch">
                      <input type="checkbox" onClick={(e) => this.onCheckChange(obj.plantype, e)} defaultChecked={obj.isActive == 1 ? "checked" : ""} data-msg={(obj.HasParentInActive === true) ? 'Parent plan should be active' : ''} />
                      <span className="slider round" />
                    </label>
                    :''
                  }</>
                  :
                  <> {obj.isActive == 1 ? <span className="blue-txt">Active</span> : <span>In Active</span>}</>
                }
              </td>
              <td style={{'width':'75px'}}>
                {
                  editBtn ? 
                  <button type="button" className="btn-icon" onClick={()=>{
                    let serObj = this.state.masterServices.filter((it)=>{
                      return (it.serviceName === obj.plantype);
                    });
                    this.setState({
                      addPlanPopup:true,
                      formType: 'Update',
                      crPlan:serObj[0] || {}
                    })
                  }}><i className="fa fa-pencil"></i></button>
                  :
                  "--"
                }
              </td>
            </tr>
            {planInfo}
            {addinfo}
            {source_order}
            {cache_days}
            {challan_source_order}
            {challan_cache_days}
            </tbody>
            </table>
          </td>
        </tr>
        </>
      )
    } else {
      return(
        <>
        <tr>
          <td>
            {obj.plantype}
            {(serObj.traversing_dependency === 'child')? <span className="subTxt"> (child plan) </span> : ''}
            <span dangerouslySetInnerHTML={{__html:toolTipInfo}}></span> <br />
            {createdAt}
          </td>
          <td>{url}</td>
          <td>{doc}</td>
          <td>
            {
              (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ?
                <label className="switch">
                  <input type="checkbox" onClick={(e) => this.onCheckChange(obj.plantype, e)} defaultChecked={obj.isActive == 1 ? "checked" : ""} data-msg={(obj.hasChildActive === true) ? 'Child should be InActive for InActive Parent plan' : ''} />
                  <span className="slider round" />
                </label>
              :
              <> {obj.isActive == 1 ? <span className="blue-txt">Active</span> : <span>In Active</span>}</>
            }
          </td>
          <td>
            {
              editBtn ? 
              <button type="button" className="btn-icon" onClick={()=>{
                let serObj = this.state.masterServices.filter((it)=>{
                  return (it.serviceName === obj.plantype);
                });
                this.setState({
                  addPlanPopup:true,
                  formType: 'Update',
                  crPlan:serObj[0] || {}
                })
              }}><i className="fa fa-pencil"></i></button>
              :
              "--"
            }
          </td>
        </tr>
        {planInfo}
        {addinfo}
        {source_order}
        {cache_days}
        {challan_source_order}
        {challan_cache_days}
        </>
      )
    }
    
  }

  printPlanInfo = (crPlan) => {
    return(
      <>
      <div className="row">
        {
          (crPlan.service_name !== "" && crPlan.service_name !== undefined) ?
          <div className="col-md-4">
            <div className="infoRow">
              <div className="key">Name</div>
              <div className="val">{crPlan.service_name}</div>
            </div>
          </div>
          :
          ""
        }
        {
          (crPlan.service_category !== "" && crPlan.service_category !== undefined) ?
          <div className="col-md-4">
            <div className="infoRow">
              <div className="key">Category</div>
              <div className="val">{crPlan.service_category}</div>
            </div>
          </div>
          :
          ""
        }
        {
          (crPlan.service_use_type !== "" && crPlan.service_use_type !== undefined) ?
          <div className="col-md-4">
            <div className="infoRow">
              <div className="key">Use Type</div>
              <div className="val">{crPlan.service_use_type}</div>
            </div>
          </div>
          :
          ""
        }
        {
          (crPlan.service_source !== "" && crPlan.service_source !== undefined) ?
          <div className="col-md-4">
            <div className="infoRow">
              <div className="key">Source</div>
              <div className="val">{crPlan.service_source}</div>
            </div>
          </div>
          :
          ""
        }
        {
          (crPlan.service_desc !== "" && crPlan.service_desc !== undefined) ?
          <div className="col-md-12">
            <div className="infoRow">
              <div className="key">Description</div>
              <div className="val">{crPlan.service_desc}</div>
            </div>
          </div>
          :
          ""
        }
      </div>
      <div className="row">
        {
          this.addinationalField(crPlan.serviceName)
        }
      </div>
      </>
    )
  }

  //updated plan status
  onCheckChange = (plantype, e) => {
    if(this.state.bbUser._id === '5fed7790648ae566a563014c') {
      if (window.confirm("Are you sure you want to update the plan "+plantype+" for Testing QA ?") === false) {
        e.preventDefault();
        return;
      }
    }
    let dataMsg = e.target.getAttribute("data-msg");
    if(dataMsg !== '') {
      Alert.error(dataMsg);
      e.preventDefault();
      return;
    }
    //return;
    const planchangeData = {
      ischecked: e.target.checked,
      buserid: this.state.bbUser._id,
      bplantype: plantype,
      //bpymntid: paymentid
    };
    $(".loader").show();
    Apihelpers.postdataresponse(PLAN_STATUS_CHANGE, planchangeData).then(res => {
      if (res.data.status === true) {
        Alert.success(res.data.message);
        setTimeout(()=>{
          window.location.href = window.location.origin + window.location.pathname;
        },2000);
        // this.getApiHitHistoryData(res.data.data[1].bbuserApiHithistoriesInfo);
      }
    });
  }

  groupPlans = () => {
    let plans = [];
    if (this.state.planlist.length > 0) {
      this.state.planlist.forEach((obj)=>{
        if(obj.parentAlsoChild !== 'yes'){
          return;
        }
        if(obj.childs !== undefined && obj.childs.length > 0) {
          plans.push(obj);
        }
      })
    }
    const graph = {};
  
    plans.forEach(({ plantype, childs }) => {
      if (!graph[plantype]) graph[plantype] = new Set();
      childs.forEach((child) => {
        graph[plantype].add(child);
        if (!graph[child]) graph[child] = new Set();
        graph[child].add(plantype);
      });
    });
  
    const visited = new Set();
    const groups = [];
  
    const dfs = (node, group) => {
      const stack = [node];
      while (stack.length) {
        const current = stack.pop();
        if (!visited.has(current)) {
          visited.add(current);
          group.push(current);
          graph[current].forEach((neighbor) => {
            if (!visited.has(neighbor)) stack.push(neighbor);
          });
        }
      }
    };
  
    Object.keys(graph).forEach((node) => {
      if (!visited.has(node)) {
        const group = [];
        dfs(node, group);
        groups.push(group);
      }
    });
  
    this.setState({groups:groups})
  }

  render(){
    return(
      <>
      {
        reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ?
          <div style={{'textAlign':'right'}}>
            <button className="btn-icon addPlan" style={{fontSize: 12, margin:'0px 2px 6px 0px'}} onClick={()=>{this.setState({addPlanPopup:true,crPlan:{},formType:'Add'})}}><i className="fa fa-plus"></i> Add Plan</button>
          </div>
          :
          null
      }
      <pre>
      {
        //JSON.stringify(this.state.planlist,null,2)
      }
      {
        //JSON.stringify(this.state.groups,null,2)
      }
      </pre>
      <div className="clientPlanList">
        <table className="table">
          <thead>
            <tr>
              <th style={{width:'25%'}}>PLAN & Created At</th>
              <th>API URL</th>
              <th style={{'width':'70px'}}>Doc </th>
              {/* <th style={{'width':'140px'}}>AMOUNT <span className="small text-center">(In Rs.)</span></th> */}
              <th style={{'width':'110px'}}>Status</th>
              <th style={{'width':'80px'}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.planlist.length > 0 ?
                this.state.planlist.map((obj, index)=>{
                  let serObj = this.state.masterServices.filter((it)=>{
                    return (it.serviceName === obj.plantype);
                  });
                  serObj = serObj[0];
                  if(serObj.traversing_dependency === 'child'){
                    return;
                  }
                  //console.log('serObj',serObj);
                  if(obj.childs !== undefined && obj.childs.length > 0) {
                    return(
                      <React.Fragment key={index}>
                        {this.planPrint(obj,index,serObj)}
                        {
                          obj.childs.map((hasPlan, indx)=>{
                            let ind = this.state.planlist.findIndex((it)=>(it.plantype === hasPlan))
                            let objChild = this.state.planlist[ind];
                            let serObjChild = this.state.masterServices.filter((it)=>{
                              return (it.serviceName === hasPlan);
                            });
                            serObjChild = serObjChild[0];
                            console.log('objChild',objChild);
                            return(<React.Fragment key={indx}>{this.planPrint(objChild,indx,serObjChild)}</React.Fragment>)
                          })
                        }
                        {
                          //this.planPrint(objChild,0,serObjChild)
                        }
                      </React.Fragment>
                    )
                    
                  } else {
                    return(
                      <React.Fragment key={index}>
                        {this.planPrint(obj,index,serObj)}
                      </React.Fragment>
                    )
                  }
                  
                })
              :
              <tr>
                <td colSpan="5"><div style={{textAlign:'center'}}>Plan is not assigned yet.</div></td>
              </tr>
            }
            {
              /*this.state.planlist.length > 0 ?
                this.state.planlist.map((obj, index)=>{
                  let serObj = this.state.masterServices.filter((it)=>{
                    return (it.serviceName === obj.plantype);
                  });
                  serObj = serObj[0];
                  if(obj.parentAlsoChild !== 'yes'){
                    return;
                  }
                  console.log('obj.parentAlsoChild',obj.parentAlsoChild);
                  if(obj.childs !== undefined && obj.childs.length > 0) {
                    return(<React.Fragment key={index}>{this.planPrint(obj,index,serObj)}</React.Fragment>);
                  }
                })
              :""*/
            }
            {
              this.state.groups.map((group, index)=>{
                return(
                  <React.Fragment key={index}>
                    <tr>
                      <td colSpan="5"><div style={{textAlign:'center'}}>These are dependent plans but don't have any parent plan &nbsp;<strong>Group: {(index+1)}</strong></div></td>
                    </tr>
                    {
                      group.map((plan,ind)=>{
                        let serObj = this.state.masterServices.filter((it)=>{
                          return (it.serviceName === plan);
                        });
                        let planObj = this.state.planlist.filter((it)=>{
                          return (it.plantype === plan);
                        });
                        let hideSwitch = 'yes';
                        if(ind === 0) {
                          hideSwitch = 'no';
                        }
                        //console.log('planObj',planObj[0]);
                        //console.log('serObj',serObj[0]);
                        let planObjFilter = planObj[0];
                        planObjFilter.HasParentInActive = false;
                        planObjFilter.hasChildActive = false;
                        return(<React.Fragment key={plan}>{this.planPrint(planObjFilter,0,serObj[0],hideSwitch)}</React.Fragment>);
                      })
                    }
                  </React.Fragment>
                )
                
              })
            }
          </tbody>
        </table>
      </div>
      

      {
        this.state.addPlanPopup ?
        <div className="customPopup add-new-plan" style={{'display':'block'}}>
          <div className="bgLayer"></div>
          <div className="popUpBox" style={{maxWidth:'700px'}}>
            <span className="closeIcon" onClick={()=>{this.setState({addPlanPopup:false})}}></span>
            <div className="popScroll" style={{maxHeight:'94vh', 'padding':'30px 40px 20px 40px'}}>
              <div className="popUpHed">
                <h3>{this.state.bbUser.name}</h3>
              </div>
              {
                //JSON.stringify(this.state.crPlanDepand, null,2)
              }
              <form className="form" onSubmit={this.updatePlanFun}>
                <div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label className="control-title">Select Plan</label>
                        <select className="form-control" onChange={(e)=>{this.changePlan(e.target.value)}} required value={this.state.crPlan.serviceName} disabled={(this.state.formType === 'Update')}>
                          <option value="">--select--</option>
                          {
                            this.state.masterServices.map((obj)=>{
                              let isAdded = false;
                              let index = this.state.planlist.findIndex(aa => aa.plantype === obj.serviceName);
                              if(index !== -1) {
                                isAdded = true;
                              }
                              let itsChild = '';
                              if(obj.traversing_dependency === 'child') {
                                itsChild = '(Dependent plan)';
                              }
                              return(<option key={obj.serviceName} value={obj.serviceName} disabled={isAdded}>{obj.serviceName} {itsChild}</option>)
                            })
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <h4 className="subTitle">Plan <span className="blue-txt ">{this.state.crPlan.serviceName}</span> Information</h4>
                  {
                    this.printPlanInfo(this.state.crPlan)
                  }
                </div>
                {(()=>{
                  if(this.state.crPlan.traversing_dependency === 'child') {
                    let crParents = this.state.crPlan.parent_id;
                    let crParentsArray = [];
                    if(crParents.length > 0) {
                      crParents.forEach((prePlanId)=>{
                        let crPrPlanObj = this.state.masterServices.filter((pln)=>(pln._id === prePlanId));

                        let index = this.state.planlist.findIndex(aa => aa.plantype === crPrPlanObj[0].serviceName);
                        if(index === -1) {
                          crParentsArray.push(crPrPlanObj[0]);
                        }
                      })
                    }
                    //console.log('crParentsArray',crParentsArray);
                    return(
                      <>
                        {
                          crParentsArray.map((its)=>{
                            return(
                              <div class="dipandePlan" data-plankey={its.serviceName} key={its._id}>
                                {
                                  //JSON.stringify(its,null,2)
                                }
                                <h4 className="subTitle">Parent Plan <span className="blue-txt ">{its.serviceName}</span> Information </h4>
                                {
                                  this.printPlanInfo(its)
                                }
                              </div>
                            )
                          },100)
                        }
                      </>
                    )
                  }
                })()}
                <div className="submitRow">
                  <button className="backBtn" type="button" onClick={()=>{
                    this.setState({addPlanPopup:false});
                    window.location.href = window.location.origin + window.location.pathname;
                    }}>Cancel</button>
                  <button className="blueBtn" type="submit">{this.state.formType} Plan</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        :""
      }
      </>
    )
  }
}

